import UploadChunkStatus from "./enums/UploadChunkStatus";
import UploadFileInformation from "./UploadFileInformation";

class UploadChunkInformation {
  public uploadRetries: number = 0;

  constructor(
    public fileInfo: UploadFileInformation,
    public chunkIndexInFile: number,
    public uploadStatus: UploadChunkStatus
  ) {}
}

export default UploadChunkInformation;
